import { render } from "./UserAdmin2.vue?vue&type=template&id=4a915fce"
import script from "./UserAdmin2.vue?vue&type=script&lang=js"
export * from "./UserAdmin2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__